import React from 'react'
function findMinMax(arr: [string, number][]) {
  let min = arr[0][1]
  let max = arr[0][1]

  for (let i = 1, len = arr.length; i < len; i++) {
    const v = arr[i][1]
    min = v < min ? v : min
    max = v > max ? v : max
  }

  return [min, max]
}
export const BarChart = ({
  data,
  title,
  maxWidth = 70,
  chartKey
}: {
  data: [string, number][]
  title?: string
  chartKey?: string
  maxWidth: number
}) => {
  const minMax = findMinMax(data)
  return (
    <div className='barChart'>
      {title && <div className='title'>{title}</div>}
      {chartKey && <div className='key'>{chartKey}</div>}
      {data.map((b, i) => {
        return (
          <div className='singleBar' key={i}>
            <div className='label'>{b[0]}</div>
            <div
              className='bar'
              style={{ width: (b[1] * maxWidth) / minMax[1] + '%' }}
            />
            <div className='value'>{b[1]}%</div>
          </div>
        )
      })}
    </div>
  )
}
